import {IPaylodAction} from '../interfaces/dispatchers/IAction'
import {ISidebar} from '../interfaces/reducers'
import SidebarAction from '../enums/ActionTypes/SidebarAction'

const initState = {currentlySelected: 'layersControl', minimize: true, long: false} as ISidebar
const application = (state: ISidebar = initState, action: IPaylodAction): ISidebar => {
  switch (action.type) {
    case SidebarAction.SET_SELECTED:
      return {...state, currentlySelected: action.payload}
    case SidebarAction.SET_MINIMIZED:
      return {...state, minimize: action.payload}
    case SidebarAction.SET_LONG:
      if (state.long != action.payload) {
        return {...state, long: action.payload}
      }
    default:
      return state
  }
}
export default application
